import React from "react";
import GridHeader from "./Grid/GridHeader";
import { Alert, Container } from "reactstrap";
import GridBody from "./Grid/GridBody";
import withRouter from "../../../components/Common/withRouter";
import { DF_MO0006Context } from "./context";

function DF_MO0006(props) {
  document.title = "Defender | Saldo Pedido";
  const location = props.router.location;
  const parseParams = new URLSearchParams(location.search);

  if (!parseParams.get("ID_Arquivo")) {
    return (
      <Alert color="danger">
        Não é possível acessar essa transação sem parametros
      </Alert>
    );
  }

  return (
    <>
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <DF_MO0006Context.Provider
        value={{
          parseParams,
        }}
      >
        <div className="page-content">
          <Container fluid={true} className="dataTable-custom-primary">
            <GridHeader />
            <GridBody />
          </Container>
        </div>
      </DF_MO0006Context.Provider>
    </>
  );
}

export default withRouter(DF_MO0006);
